import { type QueryParams } from './query-params/types';

/**
 * Generates a search URL with the given query parameters.
 * @param queryParams Record<string, string>
 * @returns search URL
 */
export function defaultGenerateSearchUrl(queryParams: QueryParams): string {
	const url = new URL(window.location.href);
	const searchParams = new URLSearchParams();
	Object.entries(queryParams).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			searchParams.set(key, String(value));
		} else {
			searchParams.delete(key);
		}
	});
	url.search = searchParams.toString();
	return url.href;
}
